export default __webpack_public_path__ + "static/media/Evaluating and Managing Cyber Risk for Investors MM.2c4304e8.pdf";